import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { BillingGuard, StaffGuard } from './@core/guards/_index.guards';

const adminAccessGuards = [StaffGuard];

// TODO: Remove legacy routes after migration to new web module is complete.
// These routes are kept for backward compatibility with old links and bookmarks.
export const routes: Routes = [
  {
    path: 'partners-notifications',
    redirectTo: 'web/partner-filtering',
    pathMatch: 'full',
  },
  {
    path: 'partners-notifications/send',
    redirectTo: 'web/partner-filtering',
    pathMatch: 'full',
  },
  {
    path: 'partners-notifications/partner-filtering',
    redirectTo: 'web/partner-filtering',
    pathMatch: 'full',
  },
  {
    path: 'partners-notifications/send-email',
    redirectTo: 'web/send-email',
    pathMatch: 'full',
  },
  {
    path: 'mapping',
    title: 'Mapping',
    loadChildren: () => import('./features/mapping/mapping.module').then((m) => m.MappingModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'content',
    title: 'Content',
    loadChildren: () => import('./features/content/content.module').then((m) => m.ContentModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'network',
    title: 'Network',
    loadChildren: () => import('./features/network/network.module').then((m) => m.NetworkModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'entities',
    title: 'Entities',
    loadChildren: () => import('./features/entities/entities.module').then((m) => m.EntitiesModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'applications',
    title: 'Applications',
    loadChildren: () => import('./features/applications/applications.module').then((m) => m.ApplicationsModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'apps',
    title: 'Apps',
    loadChildren: () => import('./features/apps/apps.module').then((m) => m.AppsModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'billing',
    title: 'Billing',
    loadChildren: () => import('./features/billing/billing.module').then((m) => m.BillingModule),
    canLoad: [...adminAccessGuards, BillingGuard],
  },
  {
    path: 'web',
    title: 'Web',
    loadChildren: () => import('./features/web/web.module').then((m) => m.WebModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canLoad: adminAccessGuards,
  },
  {
    path: 'utilities',
    title: 'Utilities',
    loadChildren: () => import('./features/utilities/utilities.module').then((m) => m.UtilitiesModule),
    canLoad: adminAccessGuards,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'dashboard' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
